<div class="name-dialog">

  <div class="name-header">
    <h2 class="name-title">
      <mat-icon>drive_file_rename_outline</mat-icon>
      {{ data.titulo || 'Nombre de Modelo' }}
    </h2>
    <button mat-icon-button (click)="onCancelClick()" class="close-button" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="name-content">
    <label class="field-label">Nombre</label>
    <input class="name-input"
           [(ngModel)]="data.name"
           [attr.maxlength]="data.maxLength || null"
           placeholder="Ingrese el nombre..."
           autofocus
           (keyup.enter)="aceptar()" />
    <span *ngIf="data.maxLength" class="name-counter" [class.excedido]="longitud > data.maxLength">
      {{ longitud }}/{{ data.maxLength }}
    </span>
    <p *ngIf="data.mensaje" class="name-hint">
      <mat-icon>info</mat-icon>
      {{ data.mensaje }}
    </p>
  </div>

  <div class="name-footer">
    <button class="btn-cancel" (click)="onCancelClick()">
      <mat-icon>close</mat-icon>
      Cancelar
    </button>
    <button class="btn-accept" (click)="aceptar()" [disabled]="!valido" cdkFocusInitial>
      <mat-icon>check</mat-icon>
      Aceptar
    </button>
  </div>

</div>
